export default "__VITE_ASSET__0BR8Yy9gzUm4Ct7fdNKHZg__";